import { toast } from "@provider/toast";
import type { MandateProvider } from "@provider/app-data-queries";

import type { MandateResult } from "./mandate-result";

export async function openBrowser(url: string, redirectUrl: string): Promise<Window | null> {
  // Zonder "noopener" in de features: daarmee geeft window.open altijd null
  // terug, ook als het venster wél openging, en kreeg iedereen de pop-upmelding.
  // De koppeling naar ons venster halen we daarna zelf weg.
  const newWindow = window.open(url, "_blank");
  if (!newWindow) {
    toast.show("Sta popup toe in rechterbovenhoek van je scherm");
    return null;
  }
  newWindow.opener = null;
  return newWindow;
}

// Query voor GET /mandate-request. Op web alleen met Mollie: dan komt de
// klant terug op /app/account?machtiging=…. eMandates kent geen terugkeer
// naar de app (de bank eindigt op "U kunt dit venster sluiten"), dus daar
// blijft het de pop-up van vroeger.
export function mandateRequestParams(provider: MandateProvider): { platform: "web" } | undefined {
  return provider === "mollie" ? { platform: "web" } : undefined;
}

// openMandate opent de machtiging (Mollie-checkout of bankpagina).
// - Mollie: geen pop-up (wordt vaak geblokkeerd): dit tabblad gaat naar
//   Mollie; de login staat al in localStorage, dus na de terugkeer op
//   /app/account?machtiging=… is de klant gewoon ingelogd (MandateReturn).
// - eMandates: de pop-up van vroeger.
export async function openMandate(url: string, provider: MandateProvider): Promise<MandateResult> {
  if (provider === "mollie") {
    window.location.assign(url);
    return "doorgestuurd";
  }
  await openBrowser(url, "de-grote-verleiding://");
  return "gesloten";
}
